<!--
 - change-item-status-dialog.component.html
 -
 - @author Monika Gole <monika.gole@ncircletech.com>
 -
 - @copyright (c) 2024 Build Centrix
 -->
<bc-templates-modal-layout
  [isLoading]="wdModelStatusService.isLoading | async"
  [loadingText]="('actions.loading'|translate)"
  (onCloseButtonClicked)="onCancel()"
>
  <!--Dialog Title-->
  <div title-content>
    {{'modelViewer.extension.changeItemStatusDialog.title'|translate}}
  </div>
  <!--Dialog Content-->
  <div body-content>
    <form [formGroup]="updateStatusForm">
      <div class="form-group">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <bc-atoms-input-group
              labelTitle="{{'modelViewer.extension.changeItemStatusDialog.selectItemStatus'|translate}}"
              labelDescription="{{'modelViewer.extension.changeItemStatusDialog.selectItemStatus'|translate}}"
            >
              <bc-atoms-typeahead
                id="updateItemStatus"
                name="updateItemStatus"
                title="{{'modelViewer.extension.changeItemStatusDialog.selectItemStatus'|translate}}"
                placeholder="{{'modelViewer.extension.changeItemStatusDialog.selectStatusFromList'|translate }}"
                labelKey="displayLabel"
                [editable]="false"
                [canClear]="true"
                [required]="true"
                [(model)]="itemStatusModel"
                [options]="statusesData.value"
                (modelChange)="onItemStatusChanged($event)"
              ></bc-atoms-typeahead>
            </bc-atoms-input-group>
          </div>
        </div>
      </div>
    </form>
  </div>
  <!--Dialog Actions-->
  <div footer-content>
    <div class="buttons-container">
      <div class="right-buttons">
        <!--Cancel/Close -->
        <bc-atoms-button
          [label]="('actions.cancel'|translate)"
          [title]="('actions.cancel'|translate)"
          [disabled]="wdModelStatusService.isLoading | async"
          [loading]="wdModelStatusService.isLoading | async"
          type="default"
          icon="cancel"
          display="block"
          size="small"
          (onButtonClicked)="onCancel()"
        ></bc-atoms-button>
        <!--Save -->
        <bc-atoms-button
          [label]="('actions.save'|translate)"
          [title]="('actions.save'|translate)"
          [loading]="wdModelStatusService.isLoading | async"
          [disabled]="(wdModelStatusService.isLoading | async) || (selectedStatus === undefined)"
          type="success"
          icon="save"
          display="block"
          size="small"
          (onButtonClicked)="onUpdate()"
        >
        </bc-atoms-button>
      </div>
    </div>
  </div>
</bc-templates-modal-layout>
